import * as React from "react";
import { QuestionContext } from "src/providers/NewQuestion";

const useNewQuestion = () => {
  return React.useContext(QuestionContext);
};

export default useNewQuestion;
